'use client';

import type { BoardCategory } from '@/types/board';

/**
 * ContentTitle 컴포넌트 Props 인터페이스
 * 
 * 콘텐츠 제목의 카테고리와 정렬 방향을 정의합니다.
 */
interface ContentTitleProps {
  category: BoardCategory;
  alignment?: 'left' | 'center';
}

/**
 * 콘텐츠 제목 컴포넌트
 * 
 * 페이지 상단에 카테고리별 제목을 표시하는 컴포넌트입니다.
 * 제목 아래에 primary 색상의 밑줄이 그어지며, 정렬 방향을 조절할 수 있습니다.
 * 
 * 주요 기능:
 * - 카테고리별 제목 표시
 * - 좌측/중앙 정렬 옵션
 * - 반응형 디자인 (모바일/데스크톱)
 * - primary 색상 밑줄 스타일링
 * - 일관된 여백 및 타이포그래피
 */
export function ContentTitle({ category, alignment = 'left' }: ContentTitleProps) {
  // 정렬 방향에 따른 헤더 클래스 설정
  const headerClasses = alignment === 'center'
    ? 'mb-4 sm:mb-6 text-center'
    : 'mb-4 sm:mb-6';

  return (
    <header className={headerClasses}>
      {/* 메인 제목 */}
      <h2 className="text-2xl sm:text-4xl font-extrabold text-foreground pb-8 sm:pb-10 lg:pb-14">
        {/* 밑줄이 있는 제목 텍스트 */}
        <span className='border-b-2 sm:border-b-3 lg:border-b-4 border-primary pb-2 sm:pb-3 lg:pb-4'>
          {category.label}
        </span>
      </h2>
    </header>
  );
} 